import { loadLocale } from "@smart/itops-locale-dom";
import { Modal } from "@smart/itops-sb-design-system-dom";

type DeleteWebEnquiryLinkModalProps = {
  open: boolean;
  loading?: boolean;
  onClose: () => void;
  onConfirm: () => Promise<void>;
};

export const DeleteWebEnquiryLinkModal = ({
  open,
  loading,
  onClose,
  onConfirm,
}: DeleteWebEnquiryLinkModalProps) => {
  const { terms } = loadLocale();

  return (
    <Modal
      dataTestId="delete-link-modal"
      header={{
        text: `Delete web ${terms.enquiry.name} link?`,
        icon: "solidGlobe",
        iconBgColor: "bg-orange-200",
      }}
      open={open}
      onClose={onClose}
      loading={loading}
      closeOptions={{
        escapeKey: false,
        clickOutside: false,
      }}
      footer={{
        buttons: [
          {
            text: "Cancel",
            type: "button",
            variant: "secondarySubtle",
            disabled: loading,
            onClick: onClose,
          },
          {
            text: "Delete Link",
            type: "button",
            variant: "primaryDefault",
            disabled: loading,
            onClick: () => onConfirm(),
          },
        ],
      }}
    >
      <p className="text-ui whitespace-pre-wrap">
        {`This will delete the web ${terms.enquiry.name} link, including its QR code. They will no longer work anywhere they've been shared. Existing submissions will not be affected.`}
      </p>
    </Modal>
  );
};
